<template>
  <div class="page-markers">
    <div
      :class="{marker: true, active: currentPage === n}"
      v-for="n in numberOfQuestions"
      :key="`marker-1-${n}`"
    ></div>
  </div>
</template>

<script>
export default {
  name: "PageMarkers",
  computed: {
    numberOfQuestions() {
      // subtract one for the intro page
      return this.$store.state.numberOfPages - 1
    },
    currentPage() {
      return this.$store.state.currentPage
    }
  }
}
</script>

<style lang="scss">
  .page-markers {
    align-items: center;
    display: flex;
    justify-content: center;
    margin: 0 auto;
    max-width: 202px;
    width: 100%;

    .marker {
      background: transparent;
      border: 1px solid $white;
      height: 7px;
      margin-right: 6px;
      width: 36px;

      &:last-of-type {
        margin-right: 0;
      }

      &.active {
        background: $secondary_green;
      }
    }
  }
</style>